module.exports = __webpack_public_path__ + "img/nav-requests.a65388d6.svg";